import { DEFAULT_COLORS } from "../../colors";
import { ID_NAMES } from "../../env";
import params from "../../params";
import { iframeSound } from "../messageTypes/iframe";

const toggleSound = ({ forceMute }) => {
    const video = document.getElementById(ID_NAMES.VIDEO)
    const iframe = document.getElementById(ID_NAMES.IFRAME)

    let muted = false;

    if (video) {

        muted = forceMute || !video.muted;

        video.muted = muted;

    } else if (iframe) {

        const src = iframe.src;
        const { search } = new URL(src);
        const searchParams = new URLSearchParams(search);

        //SWITCH SOUND BASED ON THE CURRENT PARAM
        muted = forceMute || parseInt(searchParams.get('muted')) === 0 ? true : false;

        const iframeSrc = iframeSound({
            src,
            muted
        })

        iframe.src = iframeSrc;

    }

    soundIcon(muted)


}

const soundIcon = (muted) => {

    const existingIcon = document.getElementById(ID_NAMES.SOUND)
    const { soundIconColor } = DEFAULT_COLORS

    const onSvg = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 25"><defs><clipPath id="clip-path"><rect id="Rectangle_95" data-name="Rectangle 95" width="32" height="25" transform="translate(-0.165 -0.228)" fill="none"></rect></clipPath></defs><g id="Group_54" data-name="Group 54" transform="translate(0.165 0.228)" clip-path="url(#clip-path)"><path id="Path_178" data-name="Path 178" d="M16.231,0A1.863,1.863,0,0,0,15.6.158L8.472,5.067A1.125,1.125,0,0,1,8,5.226H1.742A1.757,1.757,0,0,0,0,6.967v10.61a1.757,1.757,0,0,0,1.742,1.742H8a.849.849,0,0,1,.475.158L15.6,24.386a1.492,1.492,0,0,0,.633.158,1.567,1.567,0,0,0,1.346-1.663V1.663A1.518,1.518,0,0,0,16.231,0" fill="${soundIconColor}"></path><path id="Path_179" data-name="Path 179" d="M27.922,7.66a.84.84,0,0,0-1.188,1.188,5.646,5.646,0,0,1,0,7.759.848.848,0,0,0-.079,1.108l.079.079a.9.9,0,0,0,.633.238.616.616,0,0,0,.554-.238,7.266,7.266,0,0,0,0-10.135m2.3-2.613a.84.84,0,0,0-1.188,1.188,9.127,9.127,0,0,1,0,12.906.848.848,0,0,0-.079,1.108l.079.079a.855.855,0,0,0,.554.238.719.719,0,0,0,.554-.238,10.711,10.711,0,0,0,3.167-7.68,10.924,10.924,0,0,0-3.088-7.6M32.91,2.435A.848.848,0,0,0,31.8,2.355l-.079.079a.861.861,0,0,0,0,1.188,12.9,12.9,0,0,1,0,18.29.848.848,0,0,0-.079,1.108l.079.079a.9.9,0,0,0,.633.238.616.616,0,0,0,.554-.238,14.623,14.623,0,0,0,0-20.665" transform="translate(-5.515 -0.455)" fill="${soundIconColor}"></path></g></svg>`

    const offSvg = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 25 19"><defs><clipPath id="clip-path"><rect id="Rectangle_97" data-name="Rectangle 97" width="25" height="19" transform="translate(-0.752 0.229)" fill="none"></rect></clipPath></defs><g id="Group_55" data-name="Group 55" transform="translate(0.752 -0.229)" clip-path="url(#clip-path)"><path id="Path_180" data-name="Path 180" d="M12.284,0a.87.87,0,0,0-.422.12L6.443,3.854a.856.856,0,0,1-.361.12H1.325A1.337,1.337,0,0,0,0,5.3v8.069a1.337,1.337,0,0,0,1.325,1.325H6.082a.646.646,0,0,1,.361.12l5.419,3.733a1.116,1.116,0,0,0,.422.12A1.191,1.191,0,0,0,13.308,17.4V1.265A1.114,1.114,0,0,0,12.284,0" transform="translate(-0.752 0.395)" fill="${soundIconColor}"></path><path id="Path_181" data-name="Path 181" d="M34.987,11.185,33.6,9.8l-2.409,2.409L28.785,9.8,27.4,11.185l2.409,2.409L27.4,16l1.385,1.385,2.409-2.409L33.6,17.387,34.987,16l-2.409-2.409Z" transform="translate(-10.967 -3.844)" fill="${soundIconColor}"></path></g></svg>`

    const icon = muted ? offSvg : onSvg;

    //IF ICON EXISTING REPLACE IT
    if (existingIcon) {
        existingIcon.innerHTML = icon
        return
    }

    //IF ICON DOES NOT EXIST IT WILL BE APPENDED LATER WHEN VIDEO OR IFRAME POPS UP
    return icon

}

const createSoundIcon = () => {

    const { nosnd } = params()

    //CREATE THE SOUND SVG BOX
    const soundSvg = document.createElement("div");
    soundSvg.id = ID_NAMES.SOUND
    soundSvg.addEventListener("click", toggleSound)

    soundSvg.innerHTML = soundIcon(nosnd);

    return soundSvg

}

export { createSoundIcon, toggleSound }